import React from 'react'

interface Props extends React.PropsWithChildren {
    direction?: 'row' | 'column'
    gap?: number
    alignItems?: string
    className?: string
    onClick?: (e: React.MouseEvent) => void
    grow?: boolean
    justifyContent?: React.CSSProperties['justifyContent']
    style?: React.CSSProperties
}

export const Stack = React.forwardRef<HTMLDivElement, Props>(
    ({ style, children, direction = 'row', gap = 5, alignItems, className, onClick, grow, justifyContent }, ref) => {
        return (
            <div
                ref={ref}
                onClick={onClick}
                className={className}
                style={{
                    ...style,
                    display: 'flex',
                    flexGrow: grow ? 1 : 0,
                    flexDirection: direction,
                    gap,
                    alignItems,
                    justifyContent
                }}
            >
                {children}
            </div>
        )
    }
)
